import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded'
import LeaderboardRoundedIcon from '@mui/icons-material/LeaderboardRounded'
// import NotificationsIcon from '@mui/icons-material/Notifications'

const navigation = [
  {
    segment: 'review',
    title: 'Обзор',
    icon: <HomeRoundedIcon />,
  },
  {
    segment: 'forecasts',
    title: 'Прогнозы',
    icon: <TrendingUpRoundedIcon />,
  },
  {
    segment: 'reports',
    title: 'Отчеты',
    icon: <LeaderboardRoundedIcon />,
  },
  {
    segment: 'newsletters',
    title: 'Рассылки',
    icon: <QuestionAnswerRoundedIcon />,
  },
  // {
  //   segment: 'notifications',
  //   title: 'Уведомления',
  //   icon: <NotificationsIcon />,
  //   action: <Chip label={99} color="primary" size="small" />,
  // },
]

export const getPageTitle = (pathname) => {
  const { title } = navigation.find(({ segment }) => pathname.includes(segment))

  return title ?? ''
}

export default navigation
